import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_2y9p24nxv8: FaireCollectionEntity = {
  token: "pbc_2y9p24nxv8",
  type: "collection",
  name: "SS26 Bonbon Soleil Organic Muslin & Jersey",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1ab0466d387b2b8dac91aa4aae598ccc4d17339ec52eb19c5a89eeb1d40997dc.png",
  itemCount: 48,
  description:
    "Whimsical prints on the softest organic cotton jersey and muslin garments, perfect for spring & summertime.\n\nDigitally printed on organic cotton for exceptional clarity, softness, and durability.\n\nUltra-soft, lightweight, all-season, breathable, and comfy.\n\nNon-toxic fabrication ",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:18.134Z",
    importedBy: "entity-db-import-collections",
  },
};
